export default __webpack_public_path__ + "static/needlefilewithdust-a6a4d46db6d6e04f0fdc84949ddfafd4.png";